import { graphql } from '~publish/graphql'

import { SavedViewFields } from './SavedViewFields'

export const ReorderSavedViewsMutation = graphql(
  /* GraphQL */ `
    mutation ReorderSavedViews($input: ReorderSavedViewsInput!) {
      reorderSavedViews(input: $input) {
        __typename
        ... on SavedViewsResponse {
          savedViews {
            ...SavedViewFields
          }
        }
        ... on MutationError {
          message
        }
      }
    }
  `,
  [SavedViewFields],
)
